import React from 'react';

import { getRootEnv } from '@bringg-frontend/bringg-web-infra';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import { Button, Tooltip } from '@bringg/react-components';
import { useRoutesMonitoringTranslations } from '@bringg-frontend/monitoring';

const DocumentationLinkButton = () => {
	const { documentationLink } = useRoutesMonitoringTranslations();

	const sendDocumentationAnalyticsEvent = async (): Promise<void> => {
		const { sdk } = getRootEnv().dashboardSdk;
		await sdk.userAnalytics.trackEvent({
			key: 'CA:route-monitoring-documentation'
		});
	};

	return (
		<Tooltip title={documentationLink}>
			<Button
				shape="circle"
				type="link"
				icon={<BringgIcon iconName={BringgFontIcons.DocumenatationLink} />}
				onClick={() => {
					sendDocumentationAnalyticsEvent();
					window.open('https://help.bringg.com/docs/monitor-routes', '_blank');
				}}
				data-test-id="documentation-link"
			/>
		</Tooltip>
	);
};

export default DocumentationLinkButton;
